import React from 'react'
import { OmKort } from './IconCard.styled'
import { SliderTitelCon } from './Slider.styled'
import CardIconImg from '../images/cards_icon.png';

const Card = ({ id, title, text }) => {
    return (
        <OmKort
            key={id}
        >
            <SliderTitelCon key={title}>
                <img
                    src={CardIconImg}
                    alt={title}
                    height={100}
                    width={100}
                />
                <h2>{title}</h2>
            </SliderTitelCon>
            <p className="description">{text}</p>
        </OmKort>
    )
}

export default Card